import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHeader } from '../components/PageHeader';
import { ProgramsSection } from '../components/ProgramsSection';
import { SEO } from '../components/SEO';
import { Sprout, Heart, HandHeart, Droplets, Users, Flag } from 'lucide-react';
export function ProgramsPage() {
  const programs = [{
    icon: <Sprout className="w-12 h-12" data-id="element-765" />,
    title: 'Agriculture & Food Security',
    description: 'Promoting agricultural productivity to combat hunger, improve livelihoods, and reduce poverty in underserved communities through modern farming techniques and training.',
    color: 'bg-primary',
    stats: ['Farmer Training', 'Crop Yield Improvement', 'Food Security']
  }, {
    icon: <Heart className="w-12 h-12" data-id="element-766" />,
    title: 'Healthcare Access',
    description: 'Supporting healthcare delivery for pregnant women, children, and vulnerable adults, with a focus on prevention, care, and wellbeing through medical outreach.',
    color: 'bg-accent',
    stats: ['Medical Outreach', 'Maternal Care', 'Health Education']
  }, {
    icon: <HandHeart className="w-12 h-12" data-id="element-767" />,
    title: 'Humanitarian Services',
    description: 'Responding to urgent needs through relief interventions that improve the welfare of individuals and communities in crisis situations.',
    color: 'bg-secondary',
    stats: ['Emergency Relief', 'Crisis Response', 'Community Support']
  }, {
    icon: <Droplets className="w-12 h-12" data-id="element-768" />,
    title: 'Clean Water & Sanitation',
    description: 'Providing access to clean, safe, and sustainable water in communities where basic water infrastructure is lacking through borehole construction.',
    color: 'bg-primary',
    stats: ['Borehole Construction', 'Water Access', 'Sanitation']
  }, {
    icon: <Users className="w-12 h-12" data-id="element-769" />,
    title: 'Social Empowerment',
    description: 'Empowering the less privileged, including orphans, widows, and individuals affected by conflict or natural disasters through targeted support programs.',
    color: 'bg-accent',
    stats: ['Skills Training', 'Economic Support', 'Capacity Building']
  }, {
    icon: <Flag className="w-12 h-12" data-id="element-770" />,
    title: 'Nation Building',
    description: 'Contributing to national development by supporting initiatives that strengthen communities and promote social cohesion across Nigeria.',
    color: 'bg-secondary',
    stats: ['Community Development', 'Social Cohesion', 'Infrastructure']
  }];
  return <div className="font-sans bg-warm-ivory min-h-screen w-full" data-id="element-771">
      <SEO title="Our Programs - SFRR Foundation" description="Discover SFRR Foundation's comprehensive programs in agriculture, healthcare, humanitarian services, water & sanitation, social empowerment, and nation building." keywords="SFRR programs, agriculture Nigeria, healthcare access, humanitarian services, water sanitation, social empowerment, community development" data-id="element-772" />

      <Header data-id="element-773" />
      <main className="w-full font-sans" data-id="element-774">
        <PageHeader title="Our Programs" subtitle="Creating sustainable change through targeted interventions in six key areas" badgeText="PROGRAMS" backgroundImage="https://cdn.magicpatterns.com/uploads/25MczCAEvxUXiKQr6FhUaN/SFRR_Foundation_(2).jpg" data-id="element-775" />

        <ProgramsSection data-id="element-776" />

        {/* Detailed Programs */}
        <section className="py-20 bg-white" data-id="element-777">
          <div className="container mx-auto px-4" data-id="element-778">
            <div className="max-w-6xl mx-auto space-y-16" data-id="element-779">
              {programs.map((program, index) => <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center animate-fadeInUp`} style={{
              animationDelay: `${index * 100}ms`
            }} data-id="element-780">
                  <div className="w-full lg:w-1/2" data-id="element-781">
                    <div className={`w-20 h-20 rounded-2xl ${program.color} bg-opacity-10 flex items-center justify-center mb-6`} data-id="element-782">
                      <div className={`${program.color.replace('bg-', 'text-')}`} data-id="element-783">
                        {program.icon}
                      </div>
                    </div>
                    <h3 className="text-3xl font-serif font-bold text-charcoal mb-4" data-id="element-784">
                      {program.title}
                    </h3>
                    <p className="text-lg text-neutral-600 leading-relaxed mb-6" data-id="element-785">
                      {program.description}
                    </p>
                    <div className="flex flex-wrap gap-3" data-id="element-786">
                      {program.stats.map((stat, idx) => <span key={idx} className={`px-4 py-2 rounded-full ${program.color} bg-opacity-10 text-sm font-medium`} data-id="element-787">
                          {stat}
                        </span>)}
                    </div>
                  </div>
                  <div className="w-full lg:w-1/2" data-id="element-788">
                    <div className="aspect-video bg-neutral-100 rounded-2xl overflow-hidden shadow-soft" data-id="element-789">
                      <div className="w-full h-full bg-gradient-to-br from-primary/10 to-secondary/10 flex items-center justify-center" data-id="element-790">
                        <p className="text-neutral-400 text-sm" data-id="element-791">
                          Program Image
                        </p>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-gradient-to-br from-primary/5 to-secondary/5" data-id="element-792">
          <div className="container mx-auto px-4" data-id="element-793">
            <div className="max-w-3xl mx-auto text-center" data-id="element-794">
              <h2 className="text-3xl font-serif font-bold text-charcoal mb-6" data-id="element-795">
                Partner With Us
              </h2>
              <p className="text-lg text-neutral-600 mb-8" data-id="element-796">
                Support our programs and help us create lasting change in
                communities across Nigeria
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-797">
                <a href="/donate" className="px-8 py-4 bg-primary text-white rounded-full font-semibold hover:bg-primary-600 transition-all duration-300 hover:-translate-y-0.5 shadow-md hover:shadow-lg" data-id="element-798">
                  Support Our Programs
                </a>
                <a href="/get-involved" className="px-8 py-4 bg-white text-charcoal border-2 border-neutral-200 rounded-full font-semibold hover:border-primary hover:text-primary transition-all duration-300" data-id="element-799">
                  Get Involved
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-800" />
    </div>;
}